import { CycleProgress } from './types'

export const getReward = (cycle?: CycleProgress) => {
    if (!cycle) return 0
    for (let i = cycle.rewardsThreshold.length - 1; i >= 0; i--) {
        if (cycle.rewardsTotal >= cycle.rewardsThreshold[i]) return i + 1
    }
    return 0
}
